// extracted by mini-css-extract-plugin
module.exports = {"container":"AppLoadingSpinner_container__10OP8"};